import { message } from "antd";

export function showAdminFeedback(feedback, t) {
  if (!feedback) return;

  const translatedValues = Object.fromEntries(
    Object.entries(feedback.translatedValues || {}).map(([key, translationKey]) => [key, t(translationKey)]),
  );
  const text = feedback.messageKey
    ? t(feedback.messageKey, { ...(feedback.values || {}), ...translatedValues })
    : feedback.message;

  if (feedback.type === "error") message.error(text);
  else message.success(text);
}
